import React, {useCallback, useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {useServices} from "../../react-hooks/use-services.hook";
import {CyClass} from "../../../common/cy-classes";
import {namedSetInterval} from "../../../common/utils/time-functions";
import {AnyStyledComponent} from "styled-components";
import {ClockComponentBox} from "./boxes/clock.component.box";
import classNames from "classnames";

interface ClockComponentProps {
    format?: string
    box?: AnyStyledComponent | React.ComponentType<any>;
    className?: string;
}

export const ClockComponent: React.FC<ClockComponentProps> = observer((props) => {
    const services = useServices();

    const dateTimeFormat = props.format ? props.format : services.time.getDateTimeFormat();

    const getFormattedTime = useCallback(() => {
        const currentDate = services.time.getCurrentServerDate() ? services.time.getCurrentServerDate() : services.time.getCurrentDate();

        const currentDateInRegulationTimeZone = services.time.convertToRegulationTimeZone(currentDate);

        if (!currentDateInRegulationTimeZone) {
            return;
        }

        return services.time.format(currentDateInRegulationTimeZone.date, dateTimeFormat, currentDateInRegulationTimeZone.isUTC);
    }, [dateTimeFormat, services.time]);

    const [dateTime, setDateTime] = useState(getFormattedTime());

    const updateTime = useCallback(() => {
        const time = getFormattedTime();

        if (dateTime !== time) {
            setDateTime(time);
        }
    }, [dateTime, getFormattedTime]);

    useEffect(() => {
        const subscription = services.time.onServerTimeUpdated(updateTime);
        return () => {
            subscription.off();
        }
    }, [services.time, updateTime]);

    useEffect(() => {
        const interval = namedSetInterval('CLOCK_UPDATE_TIMER', updateTime, 1000);
        return () => {
            clearInterval(interval)
        }
    }, [services.time, updateTime]);

    const Box: AnyStyledComponent | React.ComponentType<any> = props.box ? props.box : ClockComponentBox;

    return (
        <Box className={classNames(CyClass('cy-clock-component'), props.className)}>
            <div className={CyClass('cy-clock')}>
                {dateTime}
            </div>
        </Box>
    );
});
